export function setDocumentTitle(title) {
  if (title) {
    document.title = title;
  }
}

export function setMetaDescription(description) {
  if (!description) return;

  let meta = document.querySelector("meta[name='description']");

  if (!meta) {
    meta = document.createElement("meta");
    meta.name = "description";
    document.head.appendChild(meta);
  }

  meta.setAttribute("content", description);
}
